import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=52f3b904&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/search.css?vue&type=style&index=0&id=52f3b904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3b904",
  null
  
)

export default component.exports